module.exports = __webpack_public_path__ + "img/inst1.5962b3d9.png";